import { render, staticRenderFns } from "./InnoCoreDatatable.vue?vue&type=template&id=13bb21ab"
import script from "./InnoCoreDatatable.vue?vue&type=script&lang=js"
export * from "./InnoCoreDatatable.vue?vue&type=script&lang=js"
import style0 from "./InnoCoreDatatable.vue?vue&type=style&index=0&id=13bb21ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports